/*
**************************** 
홈페이지 콘텐츠 구매 페이지
*****************************
*/

import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import PopupDom from "./PopupDom";

export default function BuyAccesoryOrder(props) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const openPostCode = function () {
        setIsPopupOpen(true);
    }
    const closePostCode = function () {
        setIsPopupOpen(false);
    }
    const [address, setAddress] = useState("");
    const callBackAddress = function (address) {
        setAddress(address);
    }

    // const PAY_URL = "https://bs-l4box.com/payment";
    // const PAY_URL = "http://13.125.167.77/payment"; //dev
    // const PAY_URL = "http://localhost:5000/buy/payment"; //local
    // const PAY_URL = "/buy/payment"; //중복구매 불가
    const PAY_URL = "/buy/storage-payment"; //중복 구매 가능
    const [userData, setUserData] = useState({ userName: "", phone: "" });
    const [proData, setProData] = useState({});
    const [totalAmount, setTotalAmount] = useState(0);
    const [color, setColor] = useState("라이트 그레이");
    const [buyAmount, SetBuyAmount] = useState(1);

    const addAmount = () => {
        SetBuyAmount(buyAmount + 1);
        totalProductPrice();
    }

    const minusAmount = () => {
        if (buyAmount - 1 > 0) {
            SetBuyAmount(buyAmount - 1);
        }
        totalProductPrice();
    }

    const totalProductPrice = () => {
        let defaultPrice = props.data.price;
        if (props.data.discount_on_off == 1) {
            defaultPrice = props.data.discount;
        }

        const delivery = 0;
        const sumPrice = defaultPrice * buyAmount + delivery;

        setTotalAmount(sumPrice);
    }

    const req = async function (userId) {
        const reqSql = "/api/users/user/" + userId;
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
            if (res.data.length > 0) {
                const user = res.data[0];
                let copyUserData = {
                    ...userData, user_id: user.id, username: user.username, name: user.name, email: user.email, phone: user.phone, address: user.address, subAddress: user.sub_address, password: user.pass
                };
                setUserData(copyUserData);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        const id = sessionStorage.getItem("userId");
        if (Number(id) !== -1 && id !== null) {
            req(id);
        }

    }, []);

    useEffect(() => {
        let copyUserData = {
            ...userData, username: props.user.username, name: props.user.name, email: props.user.email, phone: props.user.phone, address: props.user.address, subAddress: props.user.sub_address, password: props.user.pass
        };
        setUserData(copyUserData);

        let copyProdata = {
            ...proData, product_id: props.data.id, product: props.data.product, price: props.data.price, delivery: props.data.delivery, discount: props.data.discount, point: props.data.point, product_key: props.data.product_key, product_type: props.data.product_type,
            use_type: props.data.use_type, app_id: props.data.app_id, content_set_id: props.data.toktok_set_type, content_use_value: props.data.use_value
        };

        setProData(copyProdata);
    }, [props.data]);

    useEffect(() => {
        totalProductPrice();
    })

    const confirmService = useRef(false);
    const confirmPrivate = useRef(false);
    const confirmEventshop = useRef(false);
    const confirmOthershop = useRef(false);
    const confirmeCommerce = useRef(false);
    const confirmAge = useRef(false);

    const submitOrder = async (event) => {
        event.preventDefault();

        const serialKey = sessionStorage.getItem("toktokSerial");
        if (serialKey == undefined || serialKey == "" || serialKey == 'null' || serialKey == null) {
            alert("톡톡박스 시리얼번호 등록 확인해 주세요");
            return;
        } else {
            const app_id = proData.app_id;
            const product_type = proData.product_type;
            const reqSql = "/api/buy/cheack-buy-product-home";

            await axios.post(reqSql,{product_type: product_type, app_id: app_id}, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {
                if (res.data.status === '409') {
                    alert("이미 이용(구입)중 콘텐츠 입니다");
                } else {
                    if (confirmService.current === true && confirmeCommerce.current === true) {

                        let sumAddr = '';
                        let target_userName = "";
                        let target_address = "";
                        let target_subAddress = "";
                        let target_phone = "";
                        let reqOrder = "";
                        if (proData.product_type == 'content' || proData.product_type == 'content_package' || proData.product_type == 'btb_content' || proData.product_type == 'btb_content_package') {
                            sumAddr = '계정내 콘텐츠 이용권 등록';
                        } else {

                        }

                        const productDataUri = PAY_URL;
                        window.open("", "openForm", "scrollbars=no, location=no, toolbar=no, menubar=no, resizable=no, titlebar=no,  copyhistory=no, width=1000, height=700");

                        var datas_param = [["product_id", proData.app_id], ["user_id", userData.user_id], ["sumAddr", sumAddr], ["goodsName", proData.product],
                        ["amt", proData.price], ["buyerName", userData.username], ["buyerEmail", userData.email], ["buyerTel", userData.phone],
                        ["confirmeCommerce", confirmeCommerce.current], ["confirmService", confirmService.current], ["confirmPrivate", confirmPrivate.current], ["confirmEventshop", confirmEventshop.current], ["confirmOthershop", confirmOthershop.current], ["confirmAge", confirmAge.current],
                        ["target_userName", ''], ["target_address", ''], ["target_subAddress", ''],
                        ["target_phone", ''], ["reqOrder", ''], ["reqReserved", proData.product_type], ["productColor", "null"], ["use_type", proData.use_type], ["product_amount", 1], ["content_set_id", proData.content_set_id], ["content_use_value", proData.content_use_value]
                        ];

                        var f = document.createElement("form"); // form 엘리멘트 생성 
                        f.setAttribute("target", "openForm"); // method 속성을 post로 설정
                        f.setAttribute("method", "post"); // method 속성을 post로 설정
                        f.setAttribute("action", productDataUri); // submit했을 때 무슨 동작을 할 것인지 설정
                        document.body.appendChild(f); // 현재 페이지에 form 엘리멘트 추가 
                        for (var i = 0; i < datas_param.length; i++) {
                            var data_param = datas_param[i];
                            var name = data_param[0];
                            var value = data_param[1];
                            var it = document.createElement("input"); // input 엘리멘트 생성 
                            it.setAttribute("type", "hidden"); // type 속성을 hidden으로 설정
                            it.setAttribute("name", name); // name 속성을 'm_nickname'으로 설정
                            it.setAttribute("value", value); // name 속성을 'm_nickname'으로 
                            f.appendChild(it); // form 엘리멘트에 input 엘리멘트 추가 
                        }

                        f.submit(); // form 태그 서브밋 실행
                    }
                }
            }).catch(function (err) {
                console.log(err);
                if (err.code === "ERR_BAD_REQUEST") {
                    alert("세션 만료 로그인이 필요합니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            });
        }
    }

    function display(product, myimage) {
        const detailImages = myimage.split('|')

        let html;
        if (detailImages.length == 1) {
            html = "<HTML><HEAD><TITLE>" + product + "</TITLE>" +
                "</HEAD><BODY LEFTMARGIN=0 "
                + "MARGINWIDTH=0 TOPMARGIN=0 MARGINHEIGHT=0><CENTER>"
                + "<IMG SRC='" + detailImages[0] + "' BORDER=0 NAME=image "
                + "onload='window.resizeTo(document.image.width+100,document.image.height)'>"
                + "</CENTER>"
                + "</BODY></HTML>";
        } else if (detailImages.length == 2) {
            html = "<HTML><HEAD><TITLE>" + product + "</TITLE>" +
                "</HEAD><BODY LEFTMARGIN=0 "
                + "MARGINWIDTH=0 TOPMARGIN=0 MARGINHEIGHT=0><CENTER>"
                + "<IMG SRC='" + detailImages[0] + "' BORDER=0 NAME=image "
                + "onload='window.resizeTo(document.image.width+100,document.image.height)'>"
                + "<IMG SRC='" + detailImages[1] + "' BORDER=0 NAME=image1 "
                + "onload='window.resizeTo(document.image.width+100,document.image.height)'>"
                + "</CENTER>"
                + "</BODY></HTML>";
        } else {
            html = "<HTML><HEAD><TITLE>" + product + "</TITLE>" +
                "</HEAD><BODY LEFTMARGIN=0 "
                + "MARGINWIDTH=0 TOPMARGIN=0 MARGINHEIGHT=0><CENTER>"
                + "<IMG SRC='" + detailImages[0] + "' BORDER=0 NAME=image "
                + "onload='window.resizeTo(document.image.width+100,document.image.height)'>"
                + "<IMG SRC='" + detailImages[1] + "' BORDER=0 NAME=image1 "
                + "onload='window.resizeTo(document.image.width+100,document.image.height)'>"
                + "<IMG SRC='" + detailImages[2] + "' BORDER=0 NAME=image2 "
                + "onload='window.resizeTo(document.image.width+100,document.image.height)'>"
                + "</CENTER>"
                + "</BODY></HTML>";
        }

        let popup =
            window.open
                ('', '_blank', "width=500,height=400,top=100,left=100,menubar=no,toolbar=no,location=no, status=no, resizable=no, scrollbars=no");
        popup.document.open();
        popup.document.write(html);
        // popup.document.focus();
        popup.document.close();
    };

    return (
        <div>
            <div>
                <div className="modal fade" id={props.data.product_key + '_' + props.data.id} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold" id="exampleModalLabel">콘텐츠 구매하기</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-in">
                                    <form onSubmit={submitOrder} >
                                        <div className="row">
                                            <div className="col-5 my-3">
                                                <div className="card">
                                                    <img className="w-100" src={props.data.product_thum_image}></img>
                                                </div>
                                            </div>
                                            <div className="col-7 my-3 ">
                                                <h6 className="col text-start fs-5 fw-bolder " >{props.data.product}</h6>

                                                <button type="button" className="w-100 btn btn-info mt-3" onClick={function () {

                                                    display(props.data.product, props.data.detail_images);

                                                }}>상품 상세 설명 보기</button>
                                            </div>
                                        </div>

                                        <div className="p-2 text-start border border-secondary-subtle rounded-2">
                                            <h6 className="col text-start fs-6  pt-2" > {props.data.msg}</h6>
                                        </div>


                                        <div className="mt-3">
                                            <h6 className="col text-start fs-6 fw-bolder pt-2" >주문자 정보</h6>
                                        </div>
                                        <div>
                                            <h5 className="col text-start small" id="exampleModalLabel">{userData.username + " " + userData.phone}</h5>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="userName" className="form-label mt-2 small fw-bolder">이름:</label>
                                            <input type="text" className="form-control" placeholder="" name="userName" value={userData.username || ''} disabled></input>
                                        </div>
                                        <div className="form-group text-start">
                                            <label htmlFor="phone" className="form-label mt-2 small fw-bolder">전화번호:</label>
                                            <input type="tel" className="form-control" placeholder="" name="phone" value={userData.phone || ''} disabled></input>
                                        </div>

                                        <hr className="mt-4 mb-4"></hr>
                                        <div className="row pt-2 mt-2">
                                            <div className="text-start mt-2 mb-2">
                                                <h5 className="text-start fs-6 fw-bold" id="exampleModalLabel">결제상세</h5>
                                            </div>
                                            <div className="col-6 text-start smal fw-bolder"><p>총 상품금액</p></div>
                                            <div className="col-6 text-end fw-bold small fw-bolder"><p>{(props.data.price).toLocaleString()} 원</p></div>

                                            <div className="col-6 text-start small fw-bolder"><p>배송비</p></div>
                                            <div className="col-6 text-end small fw-bolder"><p>{(props.data.delivery).toLocaleString()} 원</p></div>
                                            <div className="col-6 text-start small fw-bolder"><p>즉시할인</p></div>
                                            <div className="col-6 text-end small fw-bolder"><p>{(props.data.discount).toLocaleString()} 원</p></div>

                                        </div>
                                        <hr className="mt-2 mb-4"></hr>
                                        <div className="row">
                                            <h5 className="col-6 text-start fs-6 fw-bold" ><p>최종결제금액</p></h5>
                                            <div className="col-6 text-end fw-bold"><p>{(proData.price + proData.delivery - proData.discount - proData.point).toLocaleString()} 원</p></div>
                                        </div>
                                        <hr></hr>
                                        <div className="form-group text-start mt-4 ">
                                            <h6><input type="checkbox" className="form-check-input small" name="l4age" required onClick={(e) => {
                                                confirmAge.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-none" href="#" >만14세 이상 입니다.</a></span></h6>
                                            <h6><input type="checkbox" className="form-check-input small" name="l4service" required onClick={(e) => {
                                                confirmService.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-bottom" href="https://peach-margin-2a3.notion.site/d6da601eddaa4953a20daf459ba61da0" target="_blank" onClick={() => {
                                              
                                            }}>[필수]이용약관 동의</a></span></h6>
                                           
                                            <h6><input type="checkbox" className="form-check-input small" name="l4commerce" required onClick={(e) => {
                                                confirmeCommerce.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-bottom" href="https://peach-margin-2a3.notion.site/fde5f937e1004f0bb78c72fa9344a83e" target="_blank" onClick={() => {
                                            
                                            }}>[필수]개인정보 수집 ・ 이용 동의</a></span></h6>
                                           

                                            <h6><input type="checkbox" className="form-check-input small " name="l4eventshop" onClick={(e) => {
                                                confirmEventshop.current = e.target.checked;
                                            }} defaultChecked={false}></input><span ><a className="p-2 text-muted text-decoration-bottom"
                                                href="https://peach-margin-2a3.notion.site/f86af813d9924dfbbe3236addb261413"
                                                target="_blank">[선택]이벤트/마케팅, 광고 정보 활용 및 수신 동의</a></span></h6>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                         
                                            <input type="submit" className="btn btn-lg btn-primary" value="결제하기"></input>

                                        </div >
                                        <div className="form-group mt-4 row p-2">
                                            <img className="w-100" src={props.data.notice1_image}></img>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                            {props.data.notice2_image == undefined || props.data.notice2_image == null ? null : <img className="w-100" src={props.data.notice2_image}></img>}
                                        </div>
                                    </form>
                                    <div>
                                        {isPopupOpen === true ? <PopupDom open={true} close={closePostCode} header="우편번호 검색" onClose={closePostCode} dataCall={callBackAddress}></PopupDom> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}